import { useContext } from "react";
import { ConfiguratorContext } from "../context";
import { TruckComment, NewTruckComment } from "../api/models"
import CommentCard, {EditCommentCard} from "./CommentCard";

const TruckCommentCard = (props: {
  comment:TruckComment
  onEdit: (id:number) => void
}) => {
  return <CommentCard {...props} />;
}

export const EditTruckCommentCard = (props: {
  serialNumber:string | undefined
  reset?:boolean
  comment?:TruckComment | NewTruckComment
  topicTags?: string[] | undefined
  onCancel:() => void
  onSave:(c:TruckComment) => void
}) => {
  const configurator = useContext(ConfiguratorContext);
  return <EditCommentCard {...props}
                          updateApi={async (c) => {
                            if ( !props.serialNumber ) return;

                            return await configurator.api.updateTruckComment(props.serialNumber, c);
                          }}
                          createApi={async (c) => {
                            if ( !props.serialNumber ) return;

                            return await configurator.api.createTruckComment(props.serialNumber, c);
                          }}
  />;
}

export default TruckCommentCard;

